import Actions              from "../../../model/constant/actions"
import ReducerUtils         from "../../../utils/ReducerUtils"

export const FetchingBiddingStrategySettings = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_BIDDING_STRATEGY_SETTINGS] : ()=>true,
  [Actions.RETRIEVE_BIDDING_STRATEGY_SETTINGS]   : ()=>false
})
export default FetchingBiddingStrategySettings

